export { OfficialDetailsModal } from "QuorumGrassroots/widgets/ReusableComponents/OfficialDetailsModal/OfficialDetailsModal"
export type {
    Official,
    OfficialDetailsModalProps,
} from "QuorumGrassroots/widgets/ReusableComponents/OfficialDetailsModal/OfficialDetailsModal.types"
